var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5774_28463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z",
    fill: "url(#paint0_linear_5774_28463)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.167 61.5417C53.167 56.364 57.3643 52.1667 62.542 52.1667C67.7197 52.1667 71.917 56.364 71.917 61.5417C71.917 66.7195 67.7197 70.9167 62.542 70.9167C57.3643 70.9167 53.167 66.7195 53.167 61.5417ZM57.6924 59.6384C57.4607 60.228 57.3337 60.8701 57.3337 61.5417C57.3337 64.4182 59.6655 66.7501 62.542 66.7501C63.2137 66.7501 63.8557 66.623 64.4453 66.3913L57.6924 59.6384ZM60.6387 56.6922L67.3916 63.4451C67.6232 62.8555 67.7503 62.2134 67.7503 61.5417C67.7503 58.6653 65.4185 56.3334 62.542 56.3334C61.8703 56.3334 61.2282 56.4605 60.6387 56.6922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9375 35.5001C34.9375 30.0348 39.368 25.6042 44.8333 25.6042C50.2987 25.6042 54.7292 30.0348 54.7292 35.5001C54.7292 40.9654 50.2987 45.3959 44.8333 45.3959C39.368 45.3959 34.9375 40.9654 34.9375 35.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7503 48.5208C33.8332 48.5208 26.6045 55.7495 26.6045 64.6666C26.6045 65.5295 27.3041 66.2291 28.167 66.2291H50.9505C50.3647 64.7816 50.042 63.1993 50.042 61.5416C50.042 57.176 52.2799 53.3333 55.6712 51.0976C53.1491 49.4672 50.1437 48.5208 46.917 48.5208H42.7503Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5774_28463",
    x1: 14.0587,
    y1: 14.0587,
    x2: 81.9412,
    y2: 81.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5774_28463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.eb43c2320ad31e1bf2ce58a01eefb6b1.svg";
export { ForwardRef as ReactComponent };